import { PracticeConsentsEffects } from '@practice-store/effects/consents.effects';

export const practiceEffects = [
	PracticeConsentsEffects,
];
